import dashboardConfig from '@/modules/dashboard/config'
import config from '@/config'
import * as _ from 'lodash'
import request from '@/modules/base/util/request'

/*
 * Actions
 */
const START_FETCHING_STATS_DATA = 'orgamax/dashboard/salesExpensesStats/START_FETCHING_STATS_DATA'
const START_FETCHING_ADDITIONAL_STATS_DATA = 'orgamax/dashboard/salesExpensesStats/START_FETCHING_ADDITIONAL_STATS_DATA'
const FINISHED_FETCHING_STATS_DATA = 'orgamax/dashboard/salesExpensesStats/FINISHED_FETCHING_STATS_DATA'
const ERROR_FETCHING_STATS_DATA = 'orgamax/dashboard/salesExpensesStats/ERROR_FETCHING_STATS_DATA'

/*
 * Reducer
 */
const initialState = {
  isLoading: true,
  isLoadingAdditionalStats: false,
  errorOccurred: false,
  chartData: {},
  footerData: {},
}

export default function reducer(state = initialState, action) {
  const { chartData, footerData } = action
  const currentFooterData = state.footerData
  let parsedChartData = null

  switch (action.type) {
    case START_FETCHING_STATS_DATA:
      return Object.assign({}, state, {
        isLoading: true,
        isLoadingAdditionalStats: false,
      })

    case START_FETCHING_ADDITIONAL_STATS_DATA:
      return Object.assign({}, state, {
        isLoading: false,
        isLoadingAdditionalStats: true,
      })

    case FINISHED_FETCHING_STATS_DATA:
      parsedChartData = parseChartData(chartData)

      return Object.assign({}, state, {
        isLoading: false,
        isLoadingAdditionalStats: false,
        chartData: parsedChartData,
        footerData: footerData || currentFooterData,
        errorOccurred: false,
      })

    case ERROR_FETCHING_STATS_DATA:
      return Object.assign({}, state, {
        isLoading: false,
        isLoadingAdditionalStats: false,
        errorOccurred: true,
      })

    default:
      return state
  }
}

/*
 * Action Creators
 */
const startFetchingStatsData = () => {
  return {
    type: START_FETCHING_STATS_DATA,
  }
}

const startFetchingAdditionalStatsData = () => {
  return {
    type: START_FETCHING_ADDITIONAL_STATS_DATA,
  }
}

const finishedFetchingStatsData = data => {
  return {
    type: FINISHED_FETCHING_STATS_DATA,
    chartData: data.chartData,
    footerData: data.footerData,
  }
}

const errorFetchingStatsData = () => {
  return {
    type: ERROR_FETCHING_STATS_DATA,
  }
}

const parseChartData = data => {
  const chartData = {
    labels: [],
    series: [],
    headerYearLabel: '',
    prevDataExist: data.prevDataExist,
    nextDataExist: data.nextDataExist,
  }

  const monthOrder = _.pluck(data.turnoverMonthly, 'month')

  const monthLabels = monthOrder.map(itm => config.monthNames[itm - 1])
  chartData.labels = monthLabels

  chartData.series = [
    {
      data: _.map(data.turnoverMonthly, item => {
        const meta = `${item.month}/${item.year}`

        return {
          meta,
          value: item.value,
        }
      }),
      name: 'sales',
    },
    {
      data: _.map(data.expensesMonthly, item => {
        const meta = `${item.month}/${item.year}`

        return {
          meta,
          value: item.value,
        }
      }),
      name: 'expenses',
    },
  ]

  const chartYears = data.turnoverMonthly
    .map(salesObj => salesObj.year)
    .concat(data.expensesMonthly.map(expensesObj => expensesObj.year))

  chartData.headerYearLabel = _.uniq(chartYears).join('/')

  return chartData
}

export const fetchStatsData = (monthOffset, isAdditionalRequest) => {
  return dispatch => {
    if (isAdditionalRequest) {
      dispatch(startFetchingAdditionalStatsData())
    } else {
      dispatch(startFetchingStatsData())
    }

    request(`${dashboardConfig.statistic}turnoverExpenses?monthOffset=${monthOffset}`, {
      auth: true,
      isConcurrent: true,
    })
      .then(({ body: { data: chartData } }) => {
        if (!isAdditionalRequest) {
          request(`${dashboardConfig.statistic}turnoverExpenseAggregations`, {
            auth: true,
            isConcurrent: true,
          })
            .then(({ body: { data: footerData } }) => {
              dispatch(
                finishedFetchingStatsData({
                  chartData,
                  footerData,
                }),
              )
            })
            .catch(() => {
              dispatch(errorFetchingStatsData())
            })
        } else {
          dispatch(
            finishedFetchingStatsData({
              chartData,
            }),
          )
        }
      })
      .catch(() => {
        dispatch(errorFetchingStatsData())
      })
  }
}
